import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import store from './redux/store'; 
import Login from './components/Login';
import CreateCurriculum from './components/CreateCurriculum';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { BrowserRouter, Routes, Route } from 'react-router-dom'; 
import UserList from './components/listusers';
import ServiceUploader from './components/ServiceUploader';
import UploadJson from './components/UploadJson';
import CreateBlog from './components/createblog';
import CrearOfertaEmpleo from './components/crearOfertalaboral';
import PostulacionesList from './components/PostulacionesList';
import Header from './components/Header'; 
import CommentList from './components/comenarios';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe(); 
  }, []);

  return (
    <Provider store={store}> 
      <BrowserRouter> 
        <div className="App">
          {user && <Header />} 
          {user ? (
            <Routes>
              <Route path="/create" element={<CreateCurriculum />} />
              <Route path="/list" element={<UserList />} />
              <Route path="/services" element={<ServiceUploader />} />
              <Route path="/servicios" element={<UploadJson />} />
              <Route path="/crearblog" element={<CreateBlog />} />
              <Route path="/oferta" element={<CrearOfertaEmpleo />} />
              <Route path="/postulaciones" element={<PostulacionesList />} />
              <Route path="/comentarios" element={<CommentList />} />
              <Route path="*" element={<CreateCurriculum />} />
            </Routes>
          ) : (
            <Login />
          )}
        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App;